import {apodisCoinConfig} from "@/core/config";

export default function () {
    return {
        /**
         * Convert the given amount of Euro to Apodis Coins.
         *
         * @param {number} euro
         * @return {number}
         */
        convertEuroToApodisCoin(euro = 0) {
            return apodisCoinConfig.threshold * euro / apodisCoinConfig.reward;
        },

        /**
         * Convert the given amount of Apodis Coins to Euro.
         *
         * @param {number} coins
         * @return {number}
         */
        convertApodisCoinToEuro(coins = 0) {
            return apodisCoinConfig.reward * coins / apodisCoinConfig.threshold;
        }
    };
}
